"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPalette = void 0;
const class_validator_1 = require("class-validator");
class PublicPalette {
    constructor(data) {
        this.id = data.id;
        this.variations = data.variations;
        // this.palette = data.palette
        this.colors = data.colors;
        this.name = data.name;
        this.order = data.order;
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicPalette.prototype, "id", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], PublicPalette.prototype, "variations", void 0);
__decorate([
    class_validator_1.IsObject(),
    __metadata("design:type", Object)
], PublicPalette.prototype, "colors", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicPalette.prototype, "name", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], PublicPalette.prototype, "order", void 0);
exports.PublicPalette = PublicPalette;
